import { render, staticRenderFns } from "./fpaPermanentList.vue?vue&type=template&id=14723a2a&scoped=true"
import script from "./fpaPermanentList.vue?vue&type=script&lang=js"
export * from "./fpaPermanentList.vue?vue&type=script&lang=js"
import style0 from "./fpaPermanentList.vue?vue&type=style&index=0&id=14723a2a&scoped=true&lang=scss"
import style1 from "./fpaPermanentList.vue?vue&type=style&index=1&id=14723a2a&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14723a2a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/devjobs/builds/JYRJr4p_y/0/supplyonline/covisint-cn-mcd/srm/mcd-srm-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('14723a2a')) {
      api.createRecord('14723a2a', component.options)
    } else {
      api.reload('14723a2a', component.options)
    }
    module.hot.accept("./fpaPermanentList.vue?vue&type=template&id=14723a2a&scoped=true", function () {
      api.rerender('14723a2a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/fpaManage/fpaPermanent/fpaPermanentList.vue"
export default component.exports